<template>
    <div class="responsive-table">
        <table>
            <thead>
                <tr>
                    <th v-if="tipo_periodo == 'P'">PAGAMENTO</th>
                    <th v-if="tipo_periodo == 'V'">VENCIMENTO</th>
                    <th>DEMONSTRATIVO</th>
                    <th>IMÓVEL</th>
                    <th>STATUS</th>
                    <th>VALOR(R$)</th>
                </tr>
                <tr>
                    <th colspan="5">
                        Competência:
                        {{ competencia }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <Recibo :recibo="recibo" :agrupamento="agrupamento" :propriedades="propriedades" :tipo_periodo="tipo_periodo" v-for="recibo in Recibos" :key="recibo.id"></Recibo>
                <tr>
                    <td colspan="5" align="right">
                        <strong
                            >Total da competência:
                            {{ total | number_format }}</strong
                        >
                    </td>
                </tr>
                <tr v-if="total_filial">
                    <td colspan="5" align="right">
                        <strong
                            >Total da filial:
                            {{ total_filial | number_format }}</strong
                        >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import Recibo from "./recibo.vue";
export default {
    props: [
        "competencia",
        "recibos",
        "total_filial",
        "agrupamento",
        "tipo_periodo",
        "propriedades"
    ],filters: {
        number_format(value) {
            return new Intl.NumberFormat("pt-BR", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        },
    },
    components: { Recibo },
    computed: {
        Recibos() {
            return this.recibos.filter(
                ({ Competencia }) => Competencia == this.competencia
            );
        },
        total() {
            let total = this.Recibos.reduce((acc, recibo) => acc+recibo.Valor, 0);
            return total;
        }
    },
};
</script>